var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-name"},[_c('span',[_vm._v(_vm._s(_vm.task_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }